import { useEffect, useMemo, useRef, useState } from 'react';
import { thumbUrls, uploadProfilePhoto } from '../config/api';

export default function PhotoUploadField({ label = 'Profile Photo', value, onChange, token }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [previewIndex, setPreviewIndex] = useState(0);

  const previewCandidates = useMemo(() => thumbUrls(value), [value]);
  const previewSrc = previewCandidates[previewIndex] || null;

  useEffect(() => {
    setPreviewIndex(0);
  }, [value]);

  const handlePick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;

    setError('');
    setUploading(true);
    try {
      const res = await uploadProfilePhoto(file, token);
      onChange(res.photo_relative_path);
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleClear = () => {
    setError('');
    onChange(null);
  };

  return (
    <div className="sa-field">
      <label>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: '#eee',
            border: '1px solid #ddd',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
            fontSize: 11,
            flexShrink: 0,
          }}
        >
          {previewSrc ? (
            <img
              src={previewSrc}
              alt=""
              onError={() => setPreviewIndex((current) => current + 1)}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            'No photo'
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type="button"
              className="sa-btn sa-btn-secondary"
              onClick={() => inputRef.current?.click()}
              disabled={uploading}
            >
              {uploading ? 'Uploading...' : value ? 'Replace' : 'Upload'}
            </button>
            {value && (
              <button
                type="button"
                className="sa-btn sa-btn-secondary"
                onClick={handleClear}
                disabled={uploading}
              >
                Remove
              </button>
            )}
          </div>
          {error && <div style={{ color: '#c33', fontSize: 12 }}>{error}</div>}
        </div>

        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          onChange={handlePick}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
}
